<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="12" class="page" id="p12" role="doc-pagebreak"></span><span aria-label="13" class="page" id="p13" role="doc-pagebreak"></span><a class="xref" href="#/chihayekvol190007#rpt01">Volume 1</a></h1>
<h1 class="pt"><span class="page" data-locator="p13"></span>Rules and Order</h1>
</header>
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span class="page" data-locator="p13"></span>Intelligent beings may have laws of their own making; but they also have some which they never made.</p>
<p class="ept">—Montesquieu, <i>De l’Esprit des lois</i>, I<a class="fnref" href="#/chihayekvol190038#fn106" id="fn106r" role="doc-noteref">1</a></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0012.vue?3664f61c